import React, { useEffect, useState } from 'react';
import liff from '@line/liff';
import LiffLogin from "./LiffLogin";
import '../css/liff.css';
interface EnvType {
    REACT_APP_LIFF_APP_ID: string;
}

function LiffApp() {
    const [isLiffInitialized, setIsLiffInitialized] = useState(false);
    const env = process.env as unknown as EnvType;
    const liff_id = env.REACT_APP_LIFF_APP_ID;
    useEffect(() => {
        async function initializeLiff() {
            try {
                await liff.init({ liffId: liff_id});
                setIsLiffInitialized(true);
            } catch (error) {
                console.error('LIFF initialization failed:', error);
            }
        }
        initializeLiff();
    }, []);

    return (
        <div className="App">
            {isLiffInitialized ? (
                <LiffLogin />
            ) : (
                <p>LIFFを初期化中...</p>
            )}
        </div>
    );
}

export default LiffApp;
